import { createIcon } from '../icon'
import TshirtIcon from '../svg/TshirtIcon'

export const TshirtIconDefault = createIcon(TshirtIcon)
